import { Store } from 'typesafe-actions';

import env from '@travel/env';
import { noticeError } from '@travel/tracker';

import { pushLocation } from 'store/__router/actions';
import { fetchGlobalErrorDialogAsync } from 'store/globalErrorDialog/actions';

const setCommonErrorHandler = (store: Store, isSSR?: boolean) => ({
  status,
  request,
  response,
}: {
  status: number;
  request?: Request;
  response?: Response;
}) => {
  const { dispatch } = store;
  const basename = env('UNIVERSAL_BASE_NAME') ? `/${env('UNIVERSAL_BASE_NAME')}` : '';
  if (status === 401) {
    if (isSSR) {
      dispatch(pushLocation(`${basename}/logout`));
    } else {
      dispatch(pushLocation('/logout'));
    }
  } else {
    response?.json().then(json => {
      dispatch(fetchGlobalErrorDialogAsync.success({ ...json, status }));
      if (/^50/.test(String(response.status))) {
        noticeError('API 50x Error', {
          url: response.url,
          res: response,
          json,
        });
      } else if (/^40/.test(String(response.status))) {
        noticeError('API 40x Error', {
          url: response.url,
          res: response,
          json,
        });
      }
    });
  }
};

export default setCommonErrorHandler;
